import { render, staticRenderFns } from "./appplotEdit.vue?vue&type=template&id=228ff90d&"
import script from "./appplotEdit.vue?vue&type=script&lang=js&"
export * from "./appplotEdit.vue?vue&type=script&lang=js&"
import style0 from "./appplotEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports